import { API_URL } from "../config/config";
import { getRequest, putRequest } from "../utils/axiosUtils";
import moment from "moment";
import { formatStoredPhone, getFilterQuery } from "../utils/helperFunction";

export const fetchCallScheduleList = async (
  {
  setRows,
  filterData = {},
  setRowCount
}) => {
  try {
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/schedule/all${query}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
       const pagination = response.data?.pagination
      const options = (response.data?.schedules || []).map((schedule,idx) => ({
         sNo: (pagination?.page-1)*pagination.limit + (idx+1),
        id: schedule._id,
        requestID:schedule?.requestId,
        course:schedule.course?.abbreviation || '',
        source:schedule.source || '',
        universityName: schedule.refId?.universityName || '',
        emailID: schedule.userId?.email || '',
        phoneNumber: schedule.userId?.phone ? formatStoredPhone(schedule.userId?.phone) : '-', 
        studentDetails: schedule.userId?.fullName || '',
        callType: schedule.callType || '',
        assignedTo:`${schedule?.counselorId?.firstName || ""} ${schedule?.counselorId?.lastName || ""}`.trim(),
        submitted: schedule.createdAt ? moment(schedule.createdAt).format("DD/MM/YYYY") : '',
        submittedTime: schedule.createdAt ? moment(schedule.createdAt).format("h:mm A") : '',
        preferredDate:schedule.dateTime ? moment(schedule.dateTime).format("DD/MM/YYYY") : '',
        preferredTime:schedule.dateTime ? moment(schedule.dateTime).format("h:mm A") : '',
        status:schedule?.status ||  "Pending",
        callHistory:schedule?.callHistory  ? schedule?.callHistory?.map(ele=>{
          return {
            ...ele,
            updatedBy:ele?.updatedBy ? `${ele?.updatedBy?.firstName || ""} ${ele?.updatedBy?.lastName || ""}` :"System"
          }
        }) :[]
      }));

      setRows(options);
      setRowCount && setRowCount(response.data?.pagination?.total || 0)
    } else {
      setRows([])
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchCallScheduleList error",error);
      setRows([])
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }
};


export const assignCouncilorToCall = async ({
    setSaving,
    payload,
}) => {
    try {
      setSaving(true)
    const url = `${API_URL}/schedule/assignCouncilorToScheduleCall`;

    await putRequest({url,data:payload});
    setSaving(false)
  } catch (error) {
    setSaving(false)
     throw new Error(error?.response?.data?.message || `Failed to assign counselor`);
  }
};

export const updateStatusToScheduleCall = async ({
    setSaving,
    payload,
    showSuccessNotification,
     showErrorNotification
}) => {
    try {
      setSaving(true)
    const url = `${API_URL}/schedule/updateStatusToScheduleCall`;

    const response = await putRequest({url,data:payload});
    setSaving(false)
    showSuccessNotification(response?.data?.message)
  } catch (error) {
    setSaving(false)
    console.error(error);
    showErrorNotification(error?.response?.data?.message || 'Unknown error occurred')
  }
};

export const reScheduleCallApi = async ({
    setSaving,
    payload,
    showSuccessNotification,
     showErrorNotification
}) => {
    try {
      setSaving(true)
    const url = `${API_URL}/schedule/reScheduleCall`;

    const response = await putRequest({url,data:payload});
    setSaving(false)
    showSuccessNotification(response?.data?.message)
  } catch (error) {
    setSaving(false)
    console.error(error);
    showErrorNotification(error?.response?.data?.message || 'Unknown error occurred')
  }
};

export const fetchScheduleCallHistoryList = async ({setLoading,setCallHistory,_id,showSuccessNotification, showErrorNotification}) => {
  try {
    setLoading(true)
    const url = `${API_URL}/schedule/getScheduleCallHistory/${_id}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
      const options = (response.data?.data || []).map((item) => ({
        id: item._id,
        comment: item?.comment|| '',
        updatedBy:`${item.updatedBy?.firstName || ""} ${item.updatedBy?.lastName || ""}`,
        date:item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY h:mm A") : '',
        status:item?.status ||  "Pending"
      }));
      setCallHistory(options)
    } else {
    showErrorNotification(`Unexpected response code: ${response.status}`)
    }
    setLoading(false)
  } catch (error) {
    console.error(error);
    setLoading(false)
    showErrorNotification(error?.response?.data?.message || 'Unknown error occurred')
  }
};